import React from "react";
import { FileText, CheckCircle2, HelpCircle } from "lucide-react";
import { PaperCode } from "./types";
import { useAppSelector } from "../../redux/hooks";

interface EvaluatorHeaderProps {
    selectedPaper: PaperCode;
    onTutorialClick?: () => void;
}

const EvaluatorHeader: React.FC<EvaluatorHeaderProps> = ({ selectedPaper, onTutorialClick }) => {
    const { answerSheetsTotal, answerSheetsCompleted } = useAppSelector((state: any) => state.evaluator);
    return (
        <div className="w-full  backdrop-blur-md sticky top-0 z-30">
            <div className="max-w-7xl mx-auto px-4 md:px-6 h-12 flex items-center justify-between gap-4">
                {/* Left: Identity */}
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-primary/10 rounded-lg text-primary">
                        <FileText className="w-5 h-5" />
                    </div>
                    <div>
                        <h1 className="text-base font-bold text-gray-900 leading-tight">
                            {selectedPaper.subject}
                        </h1>
                        <p className="text-xs text-gray-500 font-medium font-mono uppercase tracking-wide">
                            {selectedPaper.code}
                        </p>
                    </div>
                </div>

                {/* Right: Metrics */}
                <div className="flex items-center gap-3">
                    {onTutorialClick && (
                        <button
                            onClick={onTutorialClick}
                            className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-100 transition-colors text-gray-600 hover:text-primary"
                            title="Start Tutorial"
                        >
                            <HelpCircle className="w-4 h-4" />
                            <span className="hidden md:inline text-xs font-medium">Tutorial</span>
                        </button>
                    )}

                    <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-100">
                        <span className="text-xs text-gray-500 font-medium">Total</span>
                        <span className="text-sm font-bold text-gray-900">{answerSheetsTotal ?? 0}</span>
                    </div>
                    <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 rounded-lg border border-green-100">
                        <CheckCircle2 className="w-3.5 h-3.5 text-green-600" />
                        <span className="hidden sm:inline text-xs text-green-600 font-medium">Done</span>
                        <span className="text-sm font-bold text-green-700">{answerSheetsCompleted ?? 0}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EvaluatorHeader;
